import { getRequest } from 'config/Axios/baseConfig';

export type FeatureFlags = Record<string, boolean>;

export const fetchFeatureFlags = async (): Promise<FeatureFlags> => {
  const response = await getRequest<FeatureFlags>('api/feature-flags/');
  return response.data;
};

export const fetchPublicFlags = async (): Promise<FeatureFlags> => {
  const response = await getRequest<FeatureFlags>('api/public-flags/');
  return response.data;
};
